import React from 'react';
import { Users, Settings } from 'lucide-react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from './Tabs';
import { Button } from './Button';
import { WorkflowParticipantsTab } from './WorkflowParticipantsTab';
import { WorkflowParticipant } from '../types/workflow';
import styles from './PermissionsPanel.module.css';

interface WorkflowPermissionsPanelProps {
  workflowId: string;
  participants: (WorkflowParticipant & {
    email: string;
    displayName: string;
    avatarUrl?: string;
  })[];
  isLoading?: boolean;
  onUpdatePermission?: (participantId: string, permissionLevel: string) => void;
  onRemoveParticipant?: (participantId: string) => void;
  onInviteParticipant?: () => void;
}

export const WorkflowPermissionsPanel = ({
  workflowId,
  participants,
  isLoading = false,
  onUpdatePermission,
  onRemoveParticipant,
  onInviteParticipant,
}: WorkflowPermissionsPanelProps) => {
  return (
    <div className={styles.panel}>
      <div className={styles.header}>
        <h3 className={styles.title}>Workflow Access</h3>
        <Button
          variant="outline"
          size="sm"
          onClick={onInviteParticipant}
          className={styles.inviteButton}
        >
          <Users size={14} />
          Invite Participant
        </Button>
      </div>

      <Tabs defaultValue="participants" className={styles.tabs}>
        <TabsList className={styles.tabsList}>
          <TabsTrigger value="participants" className={styles.tabTrigger}>
            <Users size={14} className={styles.tabIcon} />
            Participants
          </TabsTrigger>
        </TabsList>

        <div className={styles.contentArea}>
          <TabsContent value="participants">
            <WorkflowParticipantsTab
              workflowId={workflowId}
              participants={participants}
              isLoading={isLoading}
              onUpdatePermission={onUpdatePermission}
              onRemoveParticipant={onRemoveParticipant}
            />
          </TabsContent>
        </div>
      </Tabs>
    </div>
  );
};
